import {z} from 'zod';

import {isNil} from 'ramda';

import {i18n} from '@dms/i18n';

export const editMaterialItemFormSchema = z
  .object({
    quantity: z.number().min(1),
    isPriceUnitManual: z.boolean(),
    sellingPricePerUnit: z.number().nullish(),
    vatType: z.string().nullish(),
    isDoNotApplyDiscount: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.isPriceUnitManual && isNil(data.sellingPricePerUnit)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
        path: ['sellingPricePerUnit'],
      });
    }
    if (data.isPriceUnitManual && isNil(data.vatType)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
        path: ['vatType'],
      });
    }
  });

export type EditMaterialItemFormType = z.infer<typeof editMaterialItemFormSchema>;
